import React from 'react'
import { Tooltip } from 'antd';
import { HistoryOutlined, ThunderboltOutlined } from '@ant-design/icons';

const clampPercentage = (value) => {
    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) {
        return 0;
    }

    return Math.min(100, Math.max(0, Math.round(numericValue)));
};

const UsageCard = ({
    remainingCredits = 0,
    totalCredits = 0,
    onHistoryClick,
    onBuyMoreClick,
    buyMoreDisabled = false,
    buyMoreTooltip = '',
}) => {
    const numericRemainingCredits = Number(remainingCredits) || 0;
    const numericTotalCredits = Number(totalCredits) || 0;
    const usedCredits = Math.max(0, numericTotalCredits - numericRemainingCredits);
    const usedPercentage = numericTotalCredits > 0
        ? clampPercentage((usedCredits / numericTotalCredits) * 100)
        : 0;
    const remainingPercentage = numericTotalCredits > 0
        ? Math.max(0, 100 - usedPercentage)
        : 0;

    return (
        <div className='myProfile-credit-card'>
            <div className='myProfile-card-top'>
                <div className='myProfile-card-title'>Credit Usage</div>
                <div className='myProfile-credit-actions'>
                    <Tooltip title='History' placement='bottom'>
                        <button
                            className='myProfile-icon-btn'
                            type='button'
                            aria-label='Transaction history'
                            onClick={onHistoryClick}
                        >
                            <HistoryOutlined />
                        </button>
                    </Tooltip>
                    <Tooltip title={buyMoreDisabled ? buyMoreTooltip : ''} placement='bottom'>
                        <span>
                            <button
                                className='myProfile-buy-btn'
                                type='button'
                                onClick={buyMoreDisabled ? undefined : onBuyMoreClick}
                                disabled={buyMoreDisabled}
                            >
                                <ThunderboltOutlined />
                                <span>Buy More</span>
                            </button>
                        </span>
                    </Tooltip>
                </div>
            </div>

            <div className='myProfile-credit-summary'>
                <div className='myProfile-credit-count'>{numericRemainingCredits}</div>
                <div className='myProfile-credit-subtitle'>Credits Remaining</div>
            </div>

            <div className='myProfile-credit-progress'>
                <div
                    className='myProfile-credit-progress-fill'
                    style={{ width: `${usedPercentage}%` }}
                />
            </div>

            <div className='myProfile-credit-footer'>
                <span>{usedPercentage}% used</span>
                <span>{usedCredits} / {numericTotalCredits}</span>
            </div>
        </div>
    );
};

export default UsageCard;
